/* Saudi routing v2: only verified shopping routes; never cart/checkout/settings. */
(function () {
  'use strict';
  function targetFor(href, cfg) {
    var u;
    try { u = new URL(href); } catch (_) { return null; }
    if (!['babybrezza.me', 'www.babybrezza.me'].includes(u.hostname)) return null;
    if (u.searchParams.has('preview_theme_id') || u.searchParams.has('preview_key') || u.searchParams.get('stay_me') === '1') return null;
    var path;
    try { path = decodeURIComponent(u.pathname).replace(/^\/(en|ar)(?=\/|$)/, '').replace(/\/$/, '') || '/'; } catch (_) { return null; }
    var language = /^\/ar(?:\/|$)/.test(u.pathname) || cfg.locale === 'ar' ? 'ar' : 'en';
    var destination, variant, product = path.match(/^\/(?:collections\/[^/]+\/)?products\/([^/]+)$/);
    if (product) {
      var canonicalHandle = cfg.productId && cfg.productIds ? cfg.productIds[cfg.productId] : product[1];
      var entry = cfg.products[canonicalHandle];
      if (!entry) return null;
      var selected = u.searchParams.get('variant') || cfg.selectedVariant;
      var match = entry.variants[selected];
      if (!match) return null; // Do not silently change colour for an obsolete/unknown ad ID.
      destination = '/products/' + encodeURIComponent(match.handle);
      variant = match.variant;
    } else if (path === '/') destination = '/';
    else {
      var collection = path.match(/^\/collections\/([^/]+)$/);
      var canonicalCollection = cfg.collectionId && cfg.collectionIds ? cfg.collectionIds[cfg.collectionId] : collection && collection[1];
      if (!collection || !cfg.collections.includes(canonicalCollection)) return null;
      destination = '/collections/' + encodeURIComponent(canonicalCollection);
    }
    var out = new URL((language === 'en' ? '/en' : '') + destination, 'https://babybrezza.sa');
    // Pass only campaign identifiers; never ME variant IDs, currency/country or customer/session tokens.
    var allowed = /^(utm_(source|medium|campaign|term|content|id|source_platform)|gclid|dclid|gbraid|wbraid|gad_source|gad_campaignid|fbclid|ttclid|msclkid|ScCid|campaignid|adgroupid|creative|keyword|device|matchtype)$/;
    u.searchParams.forEach(function (v, k) { if (allowed.test(k) && v.length <= 2048) out.searchParams.append(k, v); });
    if (variant) out.searchParams.set('variant', variant);
    out.searchParams.set('country', 'SA');
    out.searchParams.set('currency', 'SAR');
    return out.href;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { targetFor: targetFor }; return; }
  var node = document.getElementById('bb-saudi-route-config');
  if (!node || window.Shopify && window.Shopify.designMode || window.top !== window.self) return;
  var cfg;
  try { cfg = JSON.parse(node.textContent); } catch (_) { return; }
  var url = new URL(location.href), key = 'bb_saudi_redirect_at', opt = 'bb_stay_me_until';
  try {
    if (url.searchParams.get('stay_me') === '1') { localStorage.setItem(opt, String(Date.now() + 86400000)); return; }
    if (Number(localStorage.getItem(opt)) > Date.now()) return;
    if (Date.now() - Number(sessionStorage.getItem(key) || 0) < 1800000) return;
  } catch (_) { return; } // If loop protection cannot be stored, leave the visitor on ME.
  var original = location.href, destination = targetFor(original, cfg);
  if (!destination) return;
  var interacted = false;
  function stop() { interacted = true; }
  ['pointerdown', 'keydown', 'submit', 'change'].forEach(function (name) { document.addEventListener(name, stop, { capture: true, once: true }); });
  var controller = new AbortController(), started = Date.now();
  var timeout = setTimeout(function () { controller.abort(); }, 2500);
  Promise.all([
    fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin', cache: 'no-store', signal: controller.signal }).then(function (r) { if (!r.ok) throw Error('Geo unavailable'); return r.json(); }),
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', signal: controller.signal }).then(function (r) { if (!r.ok) throw Error('Cart unavailable'); return r.json(); })
  ]).then(function (results) {
    var geo = results[0], cart = results[1];
    if (interacted || location.href !== original || Date.now() - started >= 2500 || document.visibilityState === 'hidden') return;
    if (!geo.detected_values || !geo.detected_values.country || geo.detected_values.country.handle !== 'SA') return;
    if (cart.item_count !== 0) return; // Separate Shopify stores cannot transfer an existing cart.
    sessionStorage.setItem(key, String(Date.now()));
    location.replace(destination);
  }).catch(function () { /* Network failure/unknown country: keep ME usable. */ }).finally(function () {
    clearTimeout(timeout);
    ['pointerdown', 'keydown', 'submit', 'change'].forEach(function (name) { document.removeEventListener(name, stop, true); });
  });
})();
